
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import Bus from "@/lib/Bus"; const bus: Bus = new Bus().getBus();
import { Etap } from "./Etap"
import  EtapVue  from "./Etap.vue"
import  TreeShortVue  from "./TreeShort.vue"
import { ITree } from "./ITree";
import { Tree } from "./Tree";
import { Debouncer } from "@/lib/Debouncer"
import  ButtonVue from "@/lib/Button.vue";
import { IFinder, Finder } from "../finder/IFinder";
import  ClipAddVue from "@/clip/ClipAdd.vue";
import  ClipUseVue from "@/clip/ClipUse.vue";
import  ModalVue from "@/Modal.vue";
import { TreeSvc } from "./TreeSvc";
import {ITreeSvc, tree_api } from "./ITreeSvc"
import { IPrj } from "@/prj/IPrj";
import SearcherVue from "@/searcher/Searcher.vue"
import { Searcher } from "@/searcher/Searcher";
import { Next, Route } from 'vue-router';

//@Component({ components: { TreeShortVue, ButtonVue, ClipAddVue, ClipUseVue ,SearcherVue} })

@Component({
        async beforeRouteEnter(to: Route, from: Route, next: Next<TreesVue>) {
          console.log(to.params.id)
          next((vm: TreesVue) => { vm.prj_id = to.params.prj_id; console.log(vm.prj_id) });
        },
      components: { TreeShortVue, ButtonVue, ClipAddVue, ClipUseVue ,SearcherVue, ModalVue} 
})


export default class TreesVue extends Vue {
 
  prj_id:string="";
  prj_idn:string="";
  trees:ITree[] = []
  limit:number=999;
  kalk_finder:IFinder = new Finder();
  filter:string=""
  debounced:any;
  searcher:Searcher = new Searcher();

  key=0;
  listkey=0;
//        {$match:  {$expr:
//         { $gt: [{ $indexOfCP: [ { $concat: [{ $toString: { $sum:["$nr",-90000000 ]}},"#",{ $toString: "$date_created"},"@", "$idn",{ $toString: "$_id"} ]} , this.filter ] }, -1]}}}, 
  

  async debounce() {
    await this.refresh()
  }

  async searcher_changed() {
    await this.refresh();
    this.key++;
  }

  async refresh() {
    console.log("****************** trees.refresh")
    this.trees=[]
    let trees:any=[]
    const searcher=this.searcher;

    this.searcher.prj_id = this.prj_id
    trees = await new TreeSvc().find_trees_short(  this.searcher)

    if (trees) {
      this.trees=trees;
      console.log(JSON.stringify(trees[0]))
    }
    
    this.listkey++
  }

  async use_tech_from_clipboard(e:any) {

    const tree=e
    if (!tree._id) return;
    if (!confirm("Stworzyć kopię technologii "+tree.idn+"?")) return;
    const tree1 = await new TreeSvc().copy_full_tree(tree);
    if (tree1) {
      alert("Stworzono technologię "+tree1.idn)
      await this.refresh();

    }
  }

  kalk_selected() {}
  
  get_selected_trees():ITree[] {
    if (!this.trees) return[];
    let ret=[]
    for (let i=0;i<this.trees.length;i++) {
      let tree:ITree=this.trees[i]
      if ((<any>tree).selected) ret.push(tree)
    }
    return ret;
  }


  async use_prj_from_clipboard(prj:IPrj) {
    alert("Funkcja deaktywowana")
    return;
/*
    if (!(prj && prj._id && prj.type=="prj")) return;

    const sel = this.get_selected_trees();
    if (sel.length==0) {
      alert("Wybierz najpierw jakieś technologie")
      return;
    }
    if (!confirm("Przypisać projekt "+prj.idn+" wybranym technologiom (ilość:"+sel.length+") ?")) return;

    for (let i=0;i<sel.length;i++) {
      let tree:ITree=sel[i]
      tree.type = "tree"      
      const tree1 =  await new TreeSvc().assign_prj(tree, prj);

      console.log(tree1)
      if (tree1 && tree1.version) {
        tree.version = tree1.version;
        
        if (i<3) alert("Przypisano projekt "+prj.idn+" technologii "+tree.idn)
      }
      if (i>=3) alert("Przypisano projekt "+prj.idn+" "+sel.length+" technologiom ")

    }
*/
  }
/*
  async import_kalk() {
    if (this.kalk_finder && this.kalk_finder._id) {
      const tree_saved: ITree|undefined = await new TreeSvc().import_from_kalk(this.kalk_finder._id, this.prj_id)
      if (tree_saved) {
        alert("Zaimportowano kalkulację "+this.kalk_finder._id)
        window.router.push({ path: `/projekty/${this.prj_id}/technologie/${tree_saved._id}` }) 
      }
    }
  }
*/
 async del_tree(tree:any) {1
    if(!confirm("Skasować technologię?")) return;
    
    const treenew = <ITree> await new TreeSvc().del_tree(tree)
    console.log(treenew)
    if (treenew) {
      if (treenew._err.msg) {
        alert(treenew._err.msg)
      } else {
        alert("Technologia została skasowana")
        tree.del=1
        this.key++; 
      }
    }
  }


  async add_tree() {
    if (this.prj_id) {
      const tree = new Tree("prj",this.prj_id );
      const tree_saved: ITree|undefined = await new TreeSvc().update(tree)
      if (tree_saved) {
        window.router.push({ path: `/projekty/${this.prj_id}/technologie/${tree_saved._id}` }) 
      }
    } else {
      alert("Wejdź do projektu aby dodać technologie")
    }
  }

  async etykiety_projektu(prj_id:string, prj_idn:string) {
    window.router.push({ path: "/projekty/"+prj_id+"/etykiety"}) 
  }

  async projekt(prj_id:string) {
    window.router.push({ path: "/projekty/"+prj_id}) 
  }

  async show_tree(_id:string) {
    if (this.prj_id) {
      window.router.push({ path: `/projekty/${this.prj_id}/technologie/${_id}` }) 
    } else {
      window.router.push({ path: `/technologie/${_id}` }) 
    }
  }

  async mounted() {
    console.log("******* MOUNTED")
    const prj_id = this.$route.params.prj_id

    this.debounced = Debouncer.debounce(await (this.refresh.bind(this)), 1000).bind(this);
  
    if (prj_id) {
      const prj = await bus.call("/api/projekt/find_by_id", { _id: prj_id } )
      if (prj) {
        this.prj_id = prj_id
        this.prj_idn = prj.idn
      }
    } 
    //await this.refresh(); called from searcher_changed
    this.key++
  }

  



}
